import React, { useState } from "react";

const CONTACT_EMAIL = "tournamentcity100@gmail.com";

function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    const subject = encodeURIComponent(`Tournament City — message from ${name}`);
    const body = encodeURIComponent(`${message}\n\nFrom: ${name} <${email}>`);
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
  }

  return (
    <div className="mk-contact">
      <header className="mk-page-head">
        <h1 className="mk-page-title">Get in touch</h1>
        <p className="mk-page-sub">
          Questions, feedback, or ideas? We'd love to hear from you.
        </p>
      </header>

      <div className="mk-contact-body">
        <form className="mk-contact-form" onSubmit={handleSubmit}>
          <label className="mk-field">
            <span className="mk-field-label">Name</span>
            <input
              className="mk-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label className="mk-field">
            <span className="mk-field-label">Email</span>
            <input
              className="mk-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="mk-field">
            <span className="mk-field-label">Message</span>
            <textarea
              className="mk-input mk-textarea"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </label>
          <button type="submit" className="mk-btn-primary">
            Send message
          </button>
        </form>

        <div className="mk-contact-alt">
          <h3 className="mk-prod-title">Prefer email?</h3>
          <p className="mk-prod-text">
            Reach us directly at{" "}
            <a className="mk-link" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
